import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { environment } from "environments/environment";
import { AuthService } from "../core/services/auth.service";

@Injectable({
  providedIn: "root",
})
export class UserSuperAdminGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (
      AuthService.getFromStorage(environment.storageTypeUserNameApi) ===
      "adminAccess"
    ) {
      return true;
    } else {
      this.router.navigateByUrl("/public");
      return false;
    }
  }
}
